"use client";

import classNames from "classnames";
import { useEffect, ReactNode, useState } from "react";
import ReactModal from "react-modal";

import styles from "./ActionSheet.module.css";

ReactModal.setAppElement("#__next");

const ActionSheet: React.FC<ActionSheetProps> = ({
  title,
  children,
  actions,
  className,
  overlayClassName,
  onRequestClose,
  isOpen,
}) => {
  const [isMounted, setMounted] = useState<boolean>(false);

  useEffect(() => {
    if (!isOpen) {
      setMounted(false);
    }
  }, [isOpen]);

  return (
    <ReactModal
      isOpen={isOpen}
      className={classNames(styles.actionSheet, className)}
      overlayClassName={classNames(styles.overlay, overlayClassName, {
        [styles.isOpen]: isMounted && isOpen,
      })}
      bodyOpenClassName={styles.actionSheetOpenBody}
      onRequestClose={onRequestClose}
      closeTimeoutMS={300}
      onAfterOpen={() => setMounted(true)}
    >
      <h1 className={styles.title}>{title}</h1>
      <div className={styles.content}>{children}</div>
      {actions && <div className={styles.actions}>{actions}</div>}
    </ReactModal>
  );
};

export default ActionSheet;

export type ActionSheetProps = {
  children?: ReactNode;
  title: string;
  actions?: ReactNode;
  isOpen: boolean;
  className?: string;
  overlayClassName?: string;
  onRequestClose: () => void;
};
